import { useParams, Link } from "react-router-dom";
import { sampleMnemonics } from "../data/mnemonics.js";
import { useState } from "react";
import { MathJax } from "better-react-mathjax";
import './style.css';


export default function MnemonicDetail() {
  const { id } = useParams();
  const mnemonic = sampleMnemonics.find((m) => m.id === Number(id));

  // Change from single index to array of open step indexes
  const [openSteps, setOpenSteps] = useState([]);

  if (!mnemonic) {
    return <div className="p-4">Mnemonic not found or loading...</div>;
  }

  const hasSteps = Array.isArray(mnemonic.steps);

  return (
    

    
    <div className="p-4 max-w-2xl mx-auto">
      <Link to="/">
        <button className="text-white bg-gradient-to-br from-pink-500 to-orange-400 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-pink-200 dark:focus:ring-pink-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">← Back</button>
      </Link>

      <h1 className="text-3xl font-bold mb-2">{mnemonic.chapter}</h1>
      <p className="text-lg text-gray-600 mb-4">{mnemonic.concept}</p>

      <div className="bg-green-100 text-green-900 p-4 rounded-lg shadow mb-4">
        <p className="font-semibold">Mnemonic:</p>
        <p className="text-lg mt-1">{mnemonic.mnemonic}</p>
      </div>

      {mnemonic.image && (
        <img
          src={mnemonic.image}
          alt="Mnemonic Illustration"
          className="rounded-lg shadow mb-4"
        />
      )}

      {mnemonic.video && (
        <video controls className="rounded-lg shadow mb-4 w-full">
          <source src={mnemonic.video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}

      {hasSteps && (
        <div className="mt-6 ">
          <p className="font-semibold text-xl text-center mb-4 text-gray-800">
            Step-by-step Explanation
          </p>

          <div className="grid gap-4 ">
            {mnemonic.steps.map((step, index) => (
              <div 
                key={index}
                onClick={() => {
                  if (openSteps.includes(index)) {
                    // Close step
                    setOpenSteps(openSteps.filter((i) => i !== index));
                  } else {
                    // Open step
                    setOpenSteps([...openSteps, index]);
                  }
                }}
                className={`steplist rounded-xl border shadow-sm p-4 cursor-pointer transition-all duration-300 ${
                  openSteps.includes(index)
                    ? "bg-blue-50 border-blue-400 shadow-md"
                    : "bg-gray-50 border-gray-200"
                }`}
              >
                <div className="flex items-start space-x-2">
                  
                  <div>
                    <p className="font-medium text-blue-500">{`Step ${
                      index + 1
                    }`}</p>
                    {openSteps.includes(index) && (
                      
                      <MathJax>
  <p className="text-gray-700 mt-1 leading-relaxed">{step}</p>
</MathJax>
                        
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}